export default __webpack_public_path__ + "static/media/cross_white.bce08b5c.svg";